// extracted by mini-css-extract-plugin
export default {"field":"search-field_field__HMzub","icon":"search-field_icon__VuCD2"};